import { associationCampaign, isAssociationCampaignActive } from './associationCampaign'

test('keeps the campaign active through both configured calendar dates', () => {
  expect(isAssociationCampaignActive(new Date(2026, 0, 1))).toBe(true)
  expect(isAssociationCampaignActive(new Date(2027, 11, 31, 23, 59, 59))).toBe(true)
})

test('does not show the campaign before or after its configured dates', () => {
  expect(isAssociationCampaignActive(new Date(2025, 11, 31, 23, 59, 59))).toBe(false)
  expect(isAssociationCampaignActive(new Date(2028, 0, 1))).toBe(false)
})

test('keeps the campaign copy and destination easy to update', () => {
  expect(associationCampaign.activeFrom).toBe('2026-01-01')
  expect(associationCampaign.activeUntil).toBe('2027-12-31')
  expect(associationCampaign.ctaUrl).toBe('https://www.lavidaenrojo.org/hazte-amiga')
})
